import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { DIALOG_ACTION_TITLE } from "shared/labels";
import { setDeleteTarget } from "store/knowledge-base-item/knowledge-base-item.actions";
import Dialog from "../../components/Dialog";
import * as styles from "./styles.module.scss";
const RemoveConfirmDialog = ({ message, title, action, onCancel }) => {
    const dispatch = useDispatch();
    const internalOnCancel = useCallback((e) => (onCancel ? onCancel(e) : dispatch(setDeleteTarget(null))), [dispatch, onCancel]);
    return (React.createElement(Dialog, { isOpen: true, title: title, secondaryButtons: [{ onClick: internalOnCancel, label: DIALOG_ACTION_TITLE.CANCEL }], primaryButton: { onClick: action, label: DIALOG_ACTION_TITLE.OK } },
        React.createElement("div", { className: styles.info }, message)));
};
export default RemoveConfirmDialog;
